/**
 * Schema migrations of the per-user data database. Append-only: a released step is never edited.
 * `version` is the target PRAGMA user_version; consecutive integers starting at 1. The runner is
 * storage/migrate.ts.
 */

import { SCHEMA_VERSION } from '../contracts/sync.js';
import type { Migration } from '../contracts/storage.js';
import { schemaV1, schemaV2 } from './ddl.js';
import { migrateToV3 } from './migration-3.js';

export const MIGRATIONS: readonly Migration[] = [
  {
    version: 1,
    description: 'v5 data schema (specs/schema.sql) with generated dirty-marking triggers',
    up(db) {
      for (const statement of schemaV1()) db.exec(statement);
    },
  },
  {
    version: 2,
    description: 'source statistics per folder (source_days.folders / deleted), first-harvest size per source (sources.backfill_items), durable dirty usefulness buckets (stats_dirty)',
    up(db) {
      for (const statement of schemaV2()) db.exec(statement);
    },
  },
  {
    version: 3,
    description: 'scoring models (specs/models.md §4, §9.2): models, message_scores, topics.phrases, local vectors; Jev record and per-model scores derived from the existing registers',
    up(db, context) {
      migrateToV3(db, context);
    },
  },
];

/** The schema version the code expects; equals the last migration and contracts SCHEMA_VERSION. */
export const LATEST_SCHEMA_VERSION: number = MIGRATIONS[MIGRATIONS.length - 1]?.version ?? 0;

if (LATEST_SCHEMA_VERSION !== SCHEMA_VERSION) {
  throw new Error(`schema/migrations.ts ends at ${LATEST_SCHEMA_VERSION} but contracts SCHEMA_VERSION is ${SCHEMA_VERSION}`);
}
